// extracted by mini-css-extract-plugin
export default {"player":"PlayerPage_player__+J10V"};